<template>
  <div>
    <list-widget :items="zones.data" routeName="zone" :hideHeader="true" :changeRoute="true" :addNewTitle="$t('top_bar.add_new_zone')" addNewRouteName="add-zone">
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate :item="props.item"></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="zones.data">
      <slot name="footer"><a class="link" v-on:click.stop.prevent="extendLimit()" v-if="zones.data && zones.meta.current_page < zones.meta.last_page">{{ $t('common.load_more') }}</a></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListItemTemplate from 'zones/ListItemTemplate';

export default {
  components: {
    ListWidget,
    ListItemTemplate,
  },
  computed: mapGetters({
    zonesPage: 'landlord/zones/page',
    zones: 'landlord/zones/zones',
    user: 'user/user/user',
  }),
  created() {
    this.fetchZones();
  },
  methods: {
    fetchZones(updateResults) {
      this.$store.dispatch('landlord/zones/fetch', { keyword: this.$route.query.keyword, user: this.user, updateResults }).then(() => {
        if (this.zones.data.length === 0) {
          this.$router.push({ name: 'add-zone' });
        }
      });
    },
    extendLimit() {
      this.$store.commit(`landlord/zones/${mTypes.SET_PAGE}`, this.zonesPage + 1);
      this.fetchZones(true);
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/zones/Sidebar.vue